import { buildBlogPath } from "../lib/routes.js";
import { getAllBlogPosts } from "../lib/blogPosts.js";
import { createDataStore } from "../lib/dataStore.js";

const showStore = createDataStore();

function formatPublishDate(value) {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function renderBlogCardTitle(post) {
  const title = post.title ?? "";
  const accentLead = showStore.getShowById(post.showId)?.title;
  if (!accentLead || !title.startsWith(accentLead)) {
    return escapeHtml(title);
  }

  const remainingTitle = title.slice(accentLead.length);
  return `<span class="blog-card-title-show">${escapeHtml(accentLead)}</span>${escapeHtml(remainingTitle)}`;
}

export function BlogIndexPage() {
  const posts = getAllBlogPosts();
  const element = document.createElement("section");
  element.className = "page-shell blog-index-page";

  element.innerHTML = `
    <div class="blog-index-inner">
      <header class="blog-index-hero">
        <p class="blog-eyebrow">Research notes</p>
        <h1 class="blog-index-title">TV cast ages, explained.</h1>
        <p class="blog-index-dek">Premiere cast comparisons, later arrivals, and the difference between an actor's age and a character's age. Every guide includes reference dates and sources.</p>
      </header>
      <div class="blog-index-list">
        ${posts
          .map((post) => `
            <article class="blog-index-card">
              <p class="blog-card-kicker">${post.kicker} · ${formatPublishDate(post.publishDate)}</p>
              <h2 class="blog-card-title">
                <a data-link href="${buildBlogPath(post.slug)}">${renderBlogCardTitle(post)}</a>
              </h2>
              <p class="blog-card-teaser">${post.teaser}</p>
              <a class="blog-card-link" data-link href="${buildBlogPath(post.slug)}">Read the post</a>
            </article>
          `)
          .join("")}
      </div>
    </div>
  `;

  return {
    title: "Blog · HowOldHere",
    element,
  };
}
